export default __webpack_public_path__ + "static/media/attachment.c55c0af0.svg";